export default __webpack_public_path__ + "static/media/home-icon-home.a52323fd.png";